module.exports = global["PIXI"] = require("-!./pixi.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser-ce/build/custom/pixi.js-exposed
// module id = 100
// module chunks = 1